import { StyleSheet } from 'react-native'
import type { Theme } from '../../../theme/getTheme'

export const getBrandingPreviewSectionStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      width: '100%',
    },
    label: {
      fontSize: 13,
      fontWeight: '700',
      color: theme.gray[500],
      letterSpacing: 0.6,
      textTransform: 'uppercase',
      marginBottom: theme.spacing.sm,
    },
    bannerWrapper: {
      borderRadius: 12,
      overflow: 'hidden',
    },
    colorRow: {
      flexDirection: 'row',
      gap: theme.spacing.lg,
      marginTop: theme.spacing.md,
    },
    colorChip: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.sm,
    },
    colorSwatch: {
      width: 16,
      height: 16,
      borderRadius: 4,
      borderWidth: 1,
      borderColor: theme.gray[300],
    },
    colorChipLabel: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[500],
    },
  })

export const swatchColorStyle = (color: string) => ({ backgroundColor: color }) as const
